import { HeartSearchIcon } from './HeartSearchIcon';

/**
 * author: Ryan Donahue
 * id FC5F1079-0F24-415E-9364-573853A4BD34
 * name heart-search
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/heart-search.svg
 * tags
 */
export const FindLoveIcon = HeartSearchIcon;
export default FindLoveIcon